import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'; // Vuetify CSS
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// PrimeVue
import PrimeVue from "primevue/config"
// import Button from 'primevue/button';

// Theme (NEW in PrimeVue v4)
import Aura from "@primevue/themes/aura"

// Icons
import "primeicons/primeicons.css"

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
      },
    },
  },
});

//Components
import Button from 'primevue/button'
import Avatar from 'primevue/avatar'
import Tab from 'primevue/tab'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from "primevue/inputtext"
import { Tag } from 'primevue';
import Editor from 'primevue/editor';
import Badge from 'primevue/badge';
import OverlayBadge from 'primevue/overlaybadge';
import SplitButton from 'primevue/splitbutton';

createApp(App)
  .use(createPinia()) // register Pinia
  .use(router) 
  .use(vuetify) 
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false // disable automatic dark mode
      }
    }
  })
  .component('Avatar', Avatar)
  .component('Button',Button)
  .component('Tab', Tab)
  .component('DataTable', DataTable)
  .component('Column', Column)
  .component('InputText', InputText)
  .component('Tag', Tag)
  .component('Editor', Editor)
  .component('Badge', Badge)
  .component('OverlayBadge', OverlayBadge)
  .component('SplitButton', SplitButton)
  .mount('#app')        // mount the app

